/**
 * Shared table styling for the "Product Details" tabs, matched to the
 * Product List table (src/screens/lcaProduct/productList/components/ProductTable.tsx)
 * and to the equivalent ingredient details tables
 * (src/screens/lcaIngredients/ingredientDetails/components/shared/tableStyles.ts)
 * so every table across this app's details modals reads as one system:
 * white card container with rounded corners, and a primary-tinted header
 * row.
 */
export const PRODUCT_DETAILS_TABLE_CONTAINER_CLASS =
  "tw-overflow-x-auto tw-rounded-lg tw-border tw-border-border tw-bg-white";

export const PRODUCT_DETAILS_TABLE_HEADER_ROW_CLASS =
  "tw-border-b-0 tw-bg-primary/5 hover:tw-bg-primary/5 [&_th]:tw-bg-primary/5 [&_th]:tw-text-primary [&_th]:tw-font-semibold [&_th]:tw-align-middle";

export const PRODUCT_DETAILS_TABLE_ROW_CLASS = "tw-bg-white hover:tw-bg-muted/50";
